import styled from 'styled-components';

export const TitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding-bottom: 12px;
  
  h3 {
    margin: 0;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text || '#333'};
    margin-bottom: 4px;
    display: block;
  }

  input, select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #fff;
    color: #333;
    
    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
